import { Link } from "react-router-dom";

export const Logo = ({ compact = false }) => (
  <Link to="/" data-testid="logo-link" className="group inline-flex items-center">
    <img
      src="/furn-logo.png?v=2"
      alt="Furn Angling — Specialist Fishing Tackle"
      className={`w-auto object-contain transition-opacity group-hover:opacity-80 ${compact ? "h-9" : "h-11 sm:h-12"}`}
    />
  </Link>
);

export default Logo;
